module.exports = __webpack_public_path__ + "img/e_learnings.f2ac6a33.svg";